import React from "react";

/**
 * A React functional component that renders a control element.
 *
 * @param {Object} props - The properties for the Controls component.
 * @param {string} props.title - The title to display.
 * @returns {JSX.Element} The rendered Controls component.
 */
export default function Controls({ title }: { title: string }) {
  return (
    <div className="controls">
      <div className="d-flex bd-highlight">
        <h1>{title}</h1>
      </div>
    </div>
  );
}
